import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

import {setLookActiveCategory, setLookActiveFeature} from "../../../actions/lookFunctions";
import {getFeatureUrl} from "../lookNavigation/lookFunctions2";
import {getCurrentLayout} from "../../appLayout";

const WithChangeFeature = (props) => {

  const {history, children, lookActiveCategory, isMobile, setLookActiveCategory} = props;

  const changeFeature = (feature) => {
    const layout = getCurrentLayout();
    if (isMobile) {
      // const closeOnly = zoomFeature && !layout.partIdExistInQtCategory(zoomFeature.partId) && !LOOK_WALLS.includes(zoomFeature.partId);
      const closeOnly = feature && !layout.partIdExistInQtCategory(feature.partId);
      if (closeOnly) {
        history.push(getFeatureUrl(feature, true));
      } else {
        setLookActiveCategory("");
        history.push(getFeatureUrl(feature)); // always go to feature screen on mobile
      }
    } else {
      history.push(getFeatureUrl(feature, !!lookActiveCategory));
    }
  }

  return children(changeFeature)
};

const mapStateToProps = (store) => {
  const {lookActiveCategory, lookActiveFeature} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    isMobile,
    lookActiveCategory,
    lookActiveFeature,
  }
};

const mapDispatchToProps = {
  setLookActiveCategory,
  setLookActiveFeature,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WithChangeFeature)
)
